import React from 'react';
import { Spinner, Frame } from '@shopify/polaris';

interface LoadingProps {
  message?: string;
}

const Loading: React.FC<LoadingProps> = ({ message = 'Loading...' }) => {
  return (
    <Frame>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '16px'
      }}>
        <Spinner accessibilityLabel={message} size="large" />
        <p style={{ color: '#637381' }}>{message}</p>
      </div>
    </Frame>
  );
};

export default Loading;
